import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
export default function PrivateRoute({ isLoggedIn, ...props }) {
  return isLoggedIn ? <Route {...props} /> : <Redirect to="/login/" />
}
PrivateRoute.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
}
